import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import { Grid, Divider, Button, FormControl, InputLabel, Select, MenuItem } from '@material-ui/core'
import { Search } from '@material-ui/icons'
import { API, MISC } from '@const'
import SingleConfirmMsgDialog from '@msg/single-confirm-msg-dialog'
import EventPrizeDetailRedPacketDialog from '@dialogs/event-prize-detail-red-packet-dialog'
import EventPrizeDetailDragonTigerBoardDialog from '@dialogs/event-prize-detail-dragon-tiger-board-dialog'
import EventPrizeDetailFreeGameDialog from '@dialogs/event-prize-detail-free-game-dialog'
import * as utils from '@utils'
import Table from '@tables/table'
import { PfSubPfMultiSelect, CompleteDecimal } from '@select'
import { withTranslation } from 'react-i18next'
import { Decimal } from 'decimal.js'
import { ComponentDialog } from '@dialogs'

const COMPONENT_GROUP = 'event_prize';

class EventPrizePage extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key, options) => {
            return utils.t(key, 'EventPrizePage', options)
        }
    }

    state = {
        searchType: MISC.EVENT_RED_PACKET,
    }

    options = {
        export: false
    }

    columns = [
        {
            field: 'type',
            render: (rowData) => this.t('Event.' + rowData['type']),
        },
        { field: 'name' },
        {
            field: 'currency',
            render: (rowData) => this.t(`Currency.${rowData['currency']}`),
        },
        {
            field: 'pf_sub_pf_list',
            type: 'action',
            render: (rowData) => (
                <Button
                    color="primary"
                    variant="contained"
                    className={this.props.classes.button}
                    onClick={() => {
                        this.singleConfirmDialog.OpenDialog({
                            type: this.t('pfSubPfList'),
                            msg: rowData['joined_sub_pf_list'].map((pfSubPfID) => utils.GeneratePfSubPfName(pfSubPfID)).join('\n'),
                        })
                    }}>
                    {this.t('view')}
                </Button>
            ),
        },
        {
            field: 'status',
            render: (rowData) =>
                rowData['is_expired'] ? (
                    <span style={{ color: 'red' }}>{this.t('isExpired')}</span>
                ) : rowData['is_enable'] ? (
                    <span style={{ color: 'green' }}>{this.t('onGoing')}</span>
                ) : (
                    <span style={{ color: 'red' }}>{this.t('onPause')}</span>
                ),
        },
        {
            field: 'start_at',
            type: 'datetime',
        },
        {
            field: 'end_at',
            type: 'datetime',
        },
        {
            field: 'total_approved_amount',
            type: 'number',
            render: (rowData) => {
                return utils.currencyFormatter(rowData.total_approved_amount, 0, 1)
            }
        },
        {
            field: 'prized_money',
            type: 'currency',
            render: (rowData, display) => (
                <Button
                    className={this.props.classes.linkButton}
                    style={{cursor: rowData.prized_money === 0 || !rowData.prized_money ? 'default': 'pointer'}}
                    onClick={() => {
                        if (rowData.prized_money === 0 || !rowData.prized_money) return
                        this.table.SetLoading(true)
                        switch (rowData['type']) {
                            case MISC.EVENT_RED_PACKET:
                                utils.apiRequest(
                                    'get',
                                    API.RED_PACKET_DETAIL,
                                    {
                                        event_id: rowData['event_id'],
                                    },
                                    (data) => {
                                        const pfPrizedMap = {}
                                        data['rp_list']
                                            .filter((elem) => elem['pf_account'])
                                            .forEach((elem) => {
                                                if (!pfPrizedMap[elem['pf_sub_pf_id']]) pfPrizedMap[elem['pf_sub_pf_id']] = 0
                                                pfPrizedMap[elem['pf_sub_pf_id']] += elem['money']
                                            })

                                        this.singleConfirmDialog.OpenDialog({
                                            type: this.t('prizedMoney'),
                                            msg: Object.entries(pfPrizedMap)
                                                .map(
                                                    ([pfSubPfID, money]) =>
                                                        `${utils.GeneratePfSubPfName(pfSubPfID)}: ${utils.currencyFormatter(money*utils.getCurrencyRate(rowData['currency']))}`
                                                )
                                                .join('\n'),
                                        })
                                        this.table.SetLoading(false)
                                    },
                                    (_err) => {this.table.SetLoading(false)},
                                    true
                                )
                                break
                            case MISC.EVENT_DRAGON_TIGER_BOARD:
                                if (rowData['is_send_award'])
                                    utils.apiRequest(
                                        'get',
                                        API.DRAGON_TIGER_BOARD_AWARD_LIST,
                                        {
                                            event_id: rowData['event_id'],
                                        },
                                        (data) => {
                                            const pfPrizedMap = {}
                                            Object.entries(data).forEach(([_key, arr]) => {
                                                if (Array.isArray(arr))
                                                    arr.filter((elem) => elem['award_id']).forEach((elem) => {
                                                        if (!pfPrizedMap[elem['pf_sub_pf_id']]) pfPrizedMap[elem['pf_sub_pf_id']] = 0
                                                        pfPrizedMap[elem['pf_sub_pf_id']] += elem['money']
                                                    })
                                            })
                                            
                                            this.singleConfirmDialog.OpenDialog({
                                                type: this.t('prizedMoney'),
                                                msg: Object.entries(pfPrizedMap).map(([pfSubPfID, money]) => `${utils.GeneratePfSubPfName(pfSubPfID)}: ${utils.currencyFormatter(money*utils.getCurrencyRate(rowData['currency']))}`).join('\n')
                                            })
                                            this.table.SetLoading(false)
                                        },
                                        (_err) => {this.table.SetLoading(false)},
                                        true
                                    )
                                else {
                                    this.singleConfirmDialog.OpenDialog({
                                        type: this.t('prizedMoney'),
                                        msg: '',
                                    })
                                }
                                break
                            case MISC.EVENT_GIVE_FREE_GAME:
                                utils.apiRequest(
                                    'get',
                                    API.GIVE_FREE_GAME_DETAIL_PRIZE,
                                    {
                                        event_id: rowData['event_id'],
                                    },
                                    (data) => {
                                        const pfPrizedMap = {}
                                        try {
                                            data.forEach(elem=>{
                                                if (!pfPrizedMap[elem['pf_sub_pf_id']]) { pfPrizedMap[elem['pf_sub_pf_id']] = 0 }
                                                pfPrizedMap[elem['pf_sub_pf_id']] = new Decimal(pfPrizedMap[elem['pf_sub_pf_id']]).add(elem['profit'])
                                            })
                                        } catch(error) {
                                            console.log(error)
                                        }
                                        
                                        this.singleConfirmDialog.OpenDialog({
                                            type: this.t('prizedMoney'),
                                            msg: Object.entries(pfPrizedMap).map(([pfSubPfID, money]) => `${utils.GeneratePfSubPfName(pfSubPfID)}: ${utils.currencyFormatter(money*utils.getCurrencyRate(rowData['currency']))}`).join('\n')
                                        })
                                        this.table.SetLoading(false)
                                    },
                                    (_err) => {this.table.SetLoading(false)},
                                    true
                                )
                                break
                            default:
                        }
                    }}>
                    {display}
                </Button>
            ),
        },
        {
            field: 'view',
            hideTitle: true,
            type: 'action',
            render: (rowData) => {
                return (
                    <Button
                        style={{ minWidth: '72px' }}
                        onClick={() => {
                            switch (rowData['type']) {
                                case MISC.EVENT_RED_PACKET:
                                    this.redPacketDetailDialog.OpenDialog(rowData)
                                    break
                                case MISC.EVENT_DRAGON_TIGER_BOARD:
                                    this.dragonTigerDetailDialog.OpenDialog(rowData['event_id'])
                                    break
                                case MISC.EVENT_GIVE_FREE_GAME:
                                    this.compDialog.OpenDialog(
                                        this.t('detail'),
                                        <EventPrizeDetailFreeGameDialog
                                            style={{maxWidth: 1440}}
                                            compDialogArgs={{
                                                eventID: rowData['event_id'],
                                                end_at: rowData['end_at'],
                                                start_at: rowData['start_at'],
                                                isPrizePage: true
                                            }}></EventPrizeDetailFreeGameDialog>
                                    )
                                    break
                                default:
                            }
                        }}
                        variant="contained"
                        color="primary"
                        className={this.props.classes.button}>
                        {this.t('detail')}
                    </Button>
                )
            },
        },
    ]

    actions = []

    componentDidMount() {
        if (utils.checkValid(COMPONENT_GROUP + '.admin')) {
            this.columns.splice(7, 0, {
                field: 'total_amount',
                type: 'number',
                render: (rowData) => {
                    return utils.currencyFormatter(rowData.total_amount, 0, 1)
                }
            })
            this.columns.splice(9, 0, { field: 'total_money', cellStyle: { color: 'red' }, type: 'currency' })
        }
    }

    queryData(hideSuccessToast) {
        this.table.SetLoading(true)

        const queryParams = {
            filter: this.pfSelect.state.currency !== 'all' ? 'currency' : 'all_currency',
            currency: this.pfSelect.state.currency !== 'all' ? this.pfSelect.state.currency : '',
        }

        const promiseList = []

        switch (this.state.searchType) {
            case MISC.EVENT_RED_PACKET:
                promiseList.push(
                    new Promise((resolve) => {
                        this.queryRedPacketData(resolve, queryParams)
                    })
                )

                break
            case MISC.EVENT_DRAGON_TIGER_BOARD:
                promiseList.push(
                    new Promise((resolve) => {
                        this.queryDragonTigerBoardData(resolve, queryParams)
                    })
                )

                break
            case MISC.EVENT_GIVE_FREE_GAME:
                promiseList.push(
                    new Promise((resolve) => {
                        this.queryGiveFreeGameData(resolve, queryParams)
                    })
                )
                
                break
            default:
                promiseList.push(
                    new Promise((resolve) => {
                        this.queryRedPacketData(resolve, queryParams)
                    })
                )
                promiseList.push(
                    new Promise((resolve) => {
                        this.queryDragonTigerBoardData(resolve, queryParams)
                    })
                )
                promiseList.push(
                    new Promise((resolve) => {
                        this.queryGiveFreeGameData(resolve, queryParams)
                    })
                )
        }

        Promise.all(promiseList).then((respList) => {
            const tableData = []
            let isAllSuccess = true

            respList.forEach((resp) => {
                if (Array.isArray(resp)) {
                    tableData.push(...resp)
                } else if (isAllSuccess) {
                    isAllSuccess = false
                }
            })

            if (isAllSuccess && !hideSuccessToast) utils.addToast(utils.getCodeMsg('0'), 'success')

            // this.updateTableColumnTitle()
            this.table.SetData(tableData)
        })
    }

    updateTableColumnTitle() {
        this.columns.find((elem) => elem.field === 'total_money').title = this.t('totalMoney')
        this.columns.find((elem) => elem.field === 'prized_money').title = this.t('prizedMoney')
        this.table.setColumns()
    }
    componentDidUpdate(prevProps) {
        if (this.props.t !== prevProps.t) {
            this.updateTableColumnTitle()
        }
    }

    queryRedPacketData(resolve, queryParams) {
        const apiPath = utils.checkValid(COMPONENT_GROUP + '.admin') ? API.EVENT_PRIZE_ADMIN : API.EVENT_PRIZE_USER
        utils.apiRequest(
            'get',
            apiPath,
            queryParams,
            (data) => {
                const tableData = []
                data.forEach((item) => {
                    tableData.push({
                        type: MISC.EVENT_RED_PACKET,
                        event_id: item['event_id'],
                        name: item['name'],
                        currency: item['currency'],
                        joined_sub_pf_list: item['joined_sub_pf_list'],
                        is_enable: item['is_active'],
                        start_at: item['start_at'],
                        end_at: item['end_at'],
                        is_expired: item['is_expired'],
                        total_money: item['budget'] * utils.getCurrencyRate(item['currency']),
                        prized_money: item['total_issued_bonuses']* utils.getCurrencyRate(item['currency']),
                        total_amount: item['total_packet_num'],
                        total_approved_amount: item['sent_packet_num'],
                    })
                })
                resolve(tableData)
            },
            (_err) => {
                resolve()
            },
            true
        )
    }

    queryDragonTigerBoardData(resolve, queryParams) {
        utils.apiRequest(
            'get',
            API.DRAGON_TIGER_BOARD_LIST,
            queryParams,
            (data) => {
                const tableData = []

                data['dt_board_event_list'].forEach((elem) => {
                    const sent_award_list = [...elem['sent_dragon_award_list'], ...elem['sent_tiger_award_list']]
                    const prized_money = sent_award_list.length > 0 && sent_award_list.reduce((a, b) => a + b, 0)
                    const realTotalMoney = [...elem['dragon_awards'], ...elem['tiger_awards']].reduce((a, b) => a + b, 0) * utils.getCurrencyRate(elem.currency)
                    const realPrizedMoney = prized_money * utils.getCurrencyRate(elem.currency)
                    tableData.push({
                        type: MISC.EVENT_DRAGON_TIGER_BOARD,
                        event_id: elem['event_id'],
                        name: elem['event_name'],
                        currency: elem['currency'],
                        joined_sub_pf_list: elem['joined_sub_pf_list'],
                        joined_game_code_list: elem['joined_game_code_list'],
                        is_enable: elem['is_enable'],
                        start_at: elem['start_at'],
                        end_at: elem['end_at'],
                        is_expired: elem['is_expired'],
                        total_money: realTotalMoney,
                        prized_money: realPrizedMoney,
                        total_amount: elem['dragon_awards'].length + elem['tiger_awards'].length,
                        total_approved_amount: sent_award_list.length,
                        is_send_award: elem['is_send_award'],
                    })
                })

                resolve(tableData)
            },
            (_err) => {
                resolve()
            },
            true
        )
    }

    queryGiveFreeGameData(resolve, queryParams) {
        utils.apiRequest(
            'get',
            API.GIVE_FREE_GAME_LIST,
            queryParams,
            (data) => {
                const tableData = []
                data['free_spin_event_list'].forEach((elem) => {
                    tableData.push({
                        type: MISC.EVENT_GIVE_FREE_GAME,
                        event_id: elem['event_id'],
                        name: elem['name'],
                        currency: elem['currency'],
                        joined_sub_pf_list: elem['joined_sub_pf_list'],
                        joined_game_code_list: elem['joined_game_code_list'],
                        is_enable: elem['is_enable'],
                        start_at: elem['start_at'],
                        end_at: elem['end_at'],
                        is_expired: elem['is_expired'],
                        total_amount: elem['event_prize_count_total'],
                        total_approved_amount: elem['event_prize_count'],
                        total_money: elem['event_prize_money_total'] * utils.getCurrencyRate(elem['currency']),
                        prized_money: elem['prize_money_total'] * utils.getCurrencyRate(elem['currency'])
                    })
                })

                resolve(tableData)
            },
            (_err) => {
                resolve()
            },
            true
        )
    }

    render() {
        return (
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <FormControl className={this.props.classes.formControl}>
                        <InputLabel>{this.t('searchType')}</InputLabel>
                        <Select
                            value={this.state.searchType}
                            onChange={(event) =>
                                this.setState({
                                    searchType: event.target.value,
                                })
                            }>
                            {/* <MenuItem value="all">{this.t('allType')}</MenuItem> */}
                            <MenuItem value={MISC.EVENT_RED_PACKET}>{this.t('Event.' + MISC.EVENT_RED_PACKET)}</MenuItem>
                            <MenuItem value={MISC.EVENT_DRAGON_TIGER_BOARD}>{this.t('Event.' + MISC.EVENT_DRAGON_TIGER_BOARD)}</MenuItem>
                            { utils.checkValid(COMPONENT_GROUP + '.view') && <MenuItem value={MISC.EVENT_GIVE_FREE_GAME}>{this.t('Event.' + MISC.EVENT_GIVE_FREE_GAME)}</MenuItem>}
                        </Select>
                    </FormControl>
                    <PfSubPfMultiSelect onRef={(ref) => (this.pfSelect = ref)} options={{ hidePfSubPf: true }} />
                    <Button variant="contained" color="primary" className={this.props.classes.button} onClick={() => this.queryData()}>
                        <Search className={this.props.classes.rightIcon} />
                        {this.t('search')}
                    </Button>
                    <CompleteDecimal />
                </Grid>
                <Grid item xs={12}>
                    <Divider />
                </Grid>
                <Grid item xs={12}>
                    <Table
                        ownerName="EventPrizePage"
                        actions={this.actions}
                        columns={this.columns}
                        options={this.options}
                        onRef={(ref) => (this.table = ref)}
                    />
                    <SingleConfirmMsgDialog onRef={(ref) => (this.singleConfirmDialog = ref)} />
                    <EventPrizeDetailRedPacketDialog onRef={(ref) => (this.redPacketDetailDialog = ref)} />
                    <EventPrizeDetailDragonTigerBoardDialog
                        onRef={(ref) => (this.dragonTigerDetailDialog = ref)}
                        confirmCallback={() => {
                            this.queryData()
                        }}
                    />
                    <ComponentDialog onRef={(ref) => (this.compDialog = ref)}></ComponentDialog>
                </Grid>
            </Grid>
        )
    }
}

const styles = (theme) => {
    return {
        formControl: {
            margin: theme.spacing(1),
            width: '150px',
        },
        button: {
            margin: theme.spacing(1),
        },
        rightIcon: {
            marginRight: theme.spacing(1),
        },
        linkButton: {
            background: 'none!important',
            border: 'none',
            padding: '0!important',
            color: '#1890ff',
            textDecoration: 'none',
            cursor: 'pointer',
            userSelect: 'text',
            outline: 'none !important',
            '& span': {
                justifyContent: 'flex-end',
            }
        },
    }
}

EventPrizePage.propTypes = {
    classes: PropTypes.object.isRequired,
    auth: PropTypes.object,
    t: PropTypes.func,
}

export default withTranslation(['translation', 'code', 'common', 'game'])(hoc(styles)(EventPrizePage))
